import React, {Component} from 'react';
import ReactToPrint from 'react-to-print';
import couterpart from 'counterpart';

import MenuComponent2 from './MenuComponent2';
import WorkOrderDataService from '../services/WorkOrderDataService';
import WorkOrderPrint from './WorkOrderPrint';

import '../css/style.css';

class WorkOrderDetailsPrint extends Component {
    constructor() {
        super();
        this.state = {
            workOrder: {},
            workOrderId: 0
        };
    };

    componentDidMount () {
        const { id } = this.props.match.params;
        WorkOrderDataService.retrieveById(`${id}`).then(data => {
            this.setState({ 
                workOrderId: id,
                workOrder:  data
            });
        });
    }

    handlePrint(){

    }
      
    render() {
        const button_print = couterpart.translate('button_print');
        if (this.state.workOrder.workOrderNo !== undefined){
            return (
                <div>
                    <MenuComponent2/>
                    <div className="printContainer">
                        <br/>
                        <div>
                            <ReactToPrint
                            trigger={() => <button className="myButton">&nbsp;&nbsp;&nbsp;&nbsp;{button_print}&nbsp;&nbsp;&nbsp;&nbsp;</button>}
                            content={() => this.componentRef}
                            />
                            <hr/>                 
                        <WorkOrderPrint workOrder={this.state.workOrder} 
                            workOrderId={this.state.workOrderId}
                            ref={el => (this.componentRef = el)}/> 
                                                </div>                             
                    </div>
                </div>
            );
        }else{
            return (<div>&nbsp;</div>)
        }
    }
}

export default WorkOrderDetailsPrint;